import './SessionNote.css';
import { tDoor } from '../../copy/door';

export interface SessionNoteProps {
  /** O e-mail da sessão guardada. */
  email: string;
  onSignOut(): void;
}

/**
 * Com sessão, antes das 17h00 (ORD-F-153): na página inicial e na pré-apuração, no lugar do "Ver ao vivo", a linha que
 * diz que a apuração abre ali às 17h00 e o "Sair".
 */
export function SessionNote({ email, onSignOut }: SessionNoteProps) {
  return (
    <p class="session-note" data-testid="session-note">
      <span class="session-note__text">{tDoor('door.session.note', { EMAIL: email })}</span>
      <button
        type="button"
        class="session-note__out"
        data-testid="signout"
        aria-label={tDoor('door.signout.aria', { EMAIL: email })}
        onClick={onSignOut}
      >
        {tDoor('door.signout')}
      </button>
    </p>
  );
}
